import { TypeModel } from '@klant/conversational-connector/models/Type.model';
import { ConversationService } from '@klant/conversational-connector/services/conversation/conversation.service';
import { KlantConversationalConnectorService } from '@klant/conversational-connector/klant-conversational-connector.service';
import { MessageHandlerService } from '@klant/conversational-connector/services/message-handle-service/message-handler.service';
import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';

import { inject, Injectable } from '@angular/core';

import { ConversationalChatStore } from '../../../../signal-stores/conversational-chat-store/conversational-chat.store';

@Injectable({ providedIn: 'root' })
export class FaqMessageService {
    private readonly chatStore = inject(ConversationalChatStore);
    private readonly conversationService = inject(ConversationService);
    private readonly klantConversationalConnectorService = inject(KlantConversationalConnectorService);
    private readonly messageHandlerService = inject(MessageHandlerService);

    public sendFaqMessage(): void {
        const faqQuestion = this.klantConversationalConnectorService.faqMessage$.getValue();
        const canSendFaqMessage = faqQuestion && this.klantConversationalConnectorService.chatFullyLoaded;

        if (!canSendFaqMessage) {
            return;
        }

        if (this.isChattingWithAgent()) {
            this.chatStore.setShowLiveChatFaqPopUp(true);
            return;
        }

        if (this.isSameAsPreviousFaq(faqQuestion)) {
            return;
        }

        this.messageHandlerService.sendMessage(faqQuestion);

        if (this.conversationService.getChatVisibility() === ConversationalChatVisibility.MINIMIZED) {
            this.conversationService.setConversationVisibility(ConversationalChatVisibility.OPEN);
        }

        this.klantConversationalConnectorService.setPreviouslySentFaqQuestion(faqQuestion);
    }

    private isChattingWithAgent(): boolean {
        const messagesFromBotOrAgent = this.chatStore.chatMessages().filter((message) => !message.fromClient);

        if (!messagesFromBotOrAgent.length) {
            return false;
        }

        const lastMessageFromBotOrAgent = messagesFromBotOrAgent[messagesFromBotOrAgent.length - 1];

        return (
            (lastMessageFromBotOrAgent.type === TypeModel.PARTICIPANT_MESSAGE ||
                lastMessageFromBotOrAgent.type === TypeModel.PLAIN_TEXT_MESSAGE) &&
            lastMessageFromBotOrAgent.serviceName === 'livechat'
        );
    }

    private isSameAsPreviousFaq(faqQuestion: string): boolean {
        return faqQuestion === this.klantConversationalConnectorService.getPreviouslySentFaqQuestion();
    }
}
